<template>
  <div>
    <div class="row justify-content-end align-items-end">
      <div class="col"></div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'sellers-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un nouveau vendeur
        </button>
      </div>
    </div>
    <br />
    <vue-data-table
      :headers="headers"
      :data="sellers"
      :buttons="buttons"
      :summableColumns="summableColumns"
      :itemsPerPage="10"
    >
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      headers: [
        { label: "ID", field: "id", class: "text-center" },
        { label: "Référence", field: "reference", class: "text-center" },
        { label: "Nom Complet", field: "fullName", class: "text-left" },
        { label: "Prénom", field: "firstName", class: "text-left" },
        { label: "Nom", field: "lastName", class: "text-left" },
        { label: "Téléphone", field: "phone", class: "text-left" },
        { label: "E-mail", field: "email", class: "text-left" },
        {
          label: "Référence Employé",
          field: "employee_reference",
          class: "text-center",
        },
      ],
      buttons: [
        {
          label: "Details",
          icon: "bi bi-eye",
          class: "btn-secondary",
          action: (row) =>
            this.$router.push({
              name: "sellers-details",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Edit",
          icon: "bi bi-pencil",
          class: "btn-primary",
          action: (row) =>
            this.$router.push({
              name: "sellers-edit",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Delete",
          icon: "bi bi-trash",
          class: "btn-danger",
          action: (row) => this.remove(row.reference),
        },
      ],
      summableColumns: [],
    };
  },
  computed: {
    ...mapGetters("seller", {
      sellers: "getSellers",
    }),
  },
  mounted() {
    this.$store.dispatch("seller/getAll");
  },
  methods: {
    async remove(reference) {
      await this.$confirm({
        title: `Supprimer le vendeur ?`,
        message: `Vous voulez supprimer ce vendeur ?`,
        button: {
          no: "Non",
          yes: "Oui",
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("seller/destroy", reference);
          }
        },
      });
    },
    async refresh() {
      await this.$store.dispatch("seller/getAll");
    },
  },
};
</script>
